import { ApiError } from '../../../services/api/apiClient.types.js';

const ENTITLEMENT_READ_DENIED = 'TENANT_ENTITLEMENT_READ_DENIED';
const ENTITLEMENT_WRITE_DENIED = 'TENANT_ENTITLEMENT_WRITE_DENIED';

/**
 * True when the API refused the call because tenant entitlement policy denied
 * the block — not a transient failure. Call sites must hide/skip the surface
 * (never paint a permanent ScreenState/error card for missing entitlement).
 */
export function isTenantEntitlementPolicyDenied(error: unknown): boolean {
  if (!(error instanceof ApiError)) {
    return false;
  }
  return error.code === ENTITLEMENT_READ_DENIED || error.code === ENTITLEMENT_WRITE_DENIED;
}
